import _ from 'lodash';
import { Injectable } from '@angular/core';
import { RssFeed } from '../types/rss-feed';
import { LogService } from './log.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private rssFeed: RssFeed;

  constructor(private log: LogService, private http: HttpClient) {}

  getRssFeedObservable(): Observable<RssFeed> {
    if (!this.rssFeed) {
      const url = environment.api.getNewsFeed;
      this.log.trace('fetching news feed from ' + url);
      return this.http.get<RssFeed>(url).pipe(
        map(data => {
          this.rssFeed = data;
          this.log.trace(
            'news received, # of articles',
            this.rssFeed.items.length
          );
          return this.rssFeed;
        })
      );
    } else {
      this.log.trace('news feed already loaded, skipping fetch');
      return of(this.rssFeed);
    }
  }
}
